import React, { Component } from "react";
import "./Walkway.css"
class BigWalkway extends Component {
    constructor(props) {
        super(props);
    }
    render = () => {
        return (
            <div className="bigWalkway" />
        )
    };
};

export default BigWalkway;